import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class CostCenters extends Component {
    constructor() {
        super()
        this.state = {
            CostCentersList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getcostCenterListData()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getcostCenterListData = () => {
        apiService.getcostCenterDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            CostCentersList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from costCenter list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.CostCentersList).map((value,index) => {
            return {
                label : this.state.CostCentersList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select CostCenter"
                onChange={(e) => { (e) ? this.props.costCentersChange(e) : this.props.costCentersChange([])}}
                />
            </div>
        )
    }
}

export default CostCenters


// WEBPACK FOOTER //
// ./src/modules/Departments/Components/DropDowns/CostCenters.js